import { createSlice } from "@reduxjs/toolkit";

const modalStatesSlice = createSlice({
  name: "MODAL_STATES_SLICE",
  initialState: {
    isRefuseModalOpen: false,
  },
  reducers: {
    CLOSE_REFUSE_MODAL: (state) => {
      state.isRefuseModalOpen = false;
    },
    OPEN_REFUSE_MODAL: (state) => {
      state.isRefuseModalOpen = true;
    },
  },
});

export const { CLOSE_REFUSE_MODAL, OPEN_REFUSE_MODAL } =
  modalStatesSlice.actions;
export default modalStatesSlice.reducer;
